import React, { useState, useRef, useEffect } from "react";

//* import css
import cssClasses from "./CreateUser.module.css";

//* import subComponents
import ProgressCard from "../../../Subcomponents/ProgressCard";
import TabsMenu from "../../../Subcomponents/TabsMenu";

//* import Components
import AddDetails from "./AddDetails";
import AssignRole from "./AssignRole";
import Hierarchy from "./Hierarchy";

//* import images
import UsersBlueFrame from "../../../Assets/Images/Common/UsersBlueFrame.png";

//* import mui
import { Box } from "@mui/material";
import TabPanel from "@mui/lab/TabPanel";
import TabContext from "@mui/lab/TabContext";

//* import services
import { errorTost, infoTost } from "../../../Services/Toast";

//* import npm
import { useSearchParams } from "react-router-dom";
import Target from "./Target";
import AssignProject from "./AssignProject";
import { getUser, getUserByUserId } from "../../../Services/Users";
import { dismissLoader, presentLoader } from "../../../Services/loader";

function CreateUser() {
  const addDetailsRef = useRef();
  const assignRoleRef = useRef();
  const targetRef = useRef();
  const assignProjectRef = useRef();
  const [searchParams, setSearchParams] = useSearchParams();
  const userId = searchParams.get("userId");
  const userTab = searchParams.get("userTab");

  const [mainTabs, setMainTabs] = useState([
    {
      text: "Add Details",
      value: "Add Details",
      isSelected: true,
      isCompleted: false,
    },
    {
      text: "Assign Role",
      value: "Assign Role",
      isSelected: false,
      isCompleted: false,
    },
    {
      text: "Hierarchy",
      value: "Hierarchy",
      isSelected: false,
      isCompleted: false,
    },
    // { text: "Target", value: "Target", isSelected: false, isCompleted: false },
    {
      text: "Assigned Projects",
      value: "Assigned Projects",
      isSelected: false,
      isCompleted: false,
    },
  ]);
  const [userObject, setUserObject] = useState({
    name: "",
    email: "",
    contactNumber: "",
    completedTabs: [],
    isCrmUser: "",
    crmUserDocUrl: [],
    roleId: "",
    parentId: "",
    targetAmount: "",
    crmDesignation: ""
  });

  useEffect(() => {
    if (userId) {
      console.log("userId => ", userId);
      //todo user get query
      getUserFromServer();
    }
  }, [userId]);

  async function getUserFromServer() {
    presentLoader();
    const getUserByUserIdResponse = await getUserByUserId(userId);
    if (getUserByUserIdResponse.data) {
      setUserObject({ ...getUserByUserIdResponse.data });
      dismissLoader();
      console.log(
        "getUserByUserIdResponse.data -> ",
        getUserByUserIdResponse.data
      );
    } else {
      console.error(getUserByUserIdResponse);
      if (getUserByUserIdResponse?.error?.message) {
        errorTost(getUserByUserIdResponse?.error?.message);
      } else {
        errorTost("Something went wrong! Try again");
      }
      dismissLoader();
    }
  }

  useEffect(() => {
    if (userObject.completedTabs.length > 0) {
      setMainTabs([
        ...mainTabs.map((m) => ({
          ...m,
          isCompleted: userObject.completedTabs.some((s) => s === m.value),
        })),
      ]);
    }
  }, [userObject.completedTabs]);

  async function onTabChange(value) {
    if (
      mainTabs.find((f) => f.isSelected).value === "Add Details" &&
      !(await addDetailsRef.current.isLeaveComponent())
    ) {
      // console.log("addDetailsRef-isLeaveComponent => ", isLeaveComponent);
      return;
    } else if (
      mainTabs.find((f) => f.isSelected).value === "Target" &&
      !(await targetRef.current.isLeaveComponent())
    ) {
      // console.log("addDetailsRef-isLeaveComponent => ", isLeaveComponent);
      return;
    } else if (
      mainTabs.find((f) => f.isSelected).value === "Assigned Projects" &&
      !(await assignProjectRef.current.isLeaveComponent())
    ) {
      // console.log("addDetailsRef-isLeaveComponent => ", isLeaveComponent);
      return;
    } else if (
      (value === "Assign Role" ||
        value === "Target" ||
        value === "Assigned Projects") &&
      (!userObject?.userId || userObject?.userId === "")
    ) {
      searchParams.set("userTab", mainTabs.find((f) => f.isSelected).value);
      setSearchParams(searchParams);
      infoTost("Please add user details and save.");
      return;
    }

    let _pre = [...mainTabs].map((m) => ({ ...m, isSelected: false }));
    _pre[_pre.findIndex((f) => f.value === value)].isSelected = true;
    setMainTabs([..._pre]);
    searchParams.set("userTab", value);
    setSearchParams(searchParams);
  }

  useEffect(() => {
    if (mainTabs.find((f) => f.isSelected).value !== userTab) {
      onTabChange(userTab);
    }
  }, [userTab]);

  return (
    <div className={cssClasses.pageWrapper}>
      <div className={cssClasses.pageHeadingWrapper}>
        <p>{userId ? "Edit User" : "Create User"}</p>
      </div>
      {/* Show stepper only when creating new user */}
      {!userId && (
        <div className={cssClasses.progressCardWrapper}>
          <ProgressCard
            image={UsersBlueFrame}
            timeline={mainTabs.filter((f) => f.value !== "Hierarchy")}
            cardTitle={"Create a User"}
            totalProgress={mainTabs.filter((f) => f.value !== "Hierarchy").length}
            currentProgress={
              mainTabs
                .filter((f) => f.value !== "Hierarchy")
                .filter((f) => f.isCompleted).length
            }
            defaultExpanded={false}
            sx={{ ".imageWrapper": {}, ".image": {} }}
          />
        </div>
      )}
      {/* Summary bar — only for existing user */}
      {userId && userObject?.name && (
        <div style={{
          display: "flex", alignItems: "center", gap: "1.6rem",
          padding: "1rem 2rem", background: "#F9FAFB",
          borderBottom: "1px solid #EAECF0", flexWrap: "wrap",
        }}>
          <div style={{
            width: "3.6rem", height: "3.6rem", borderRadius: "50%",
            background: "#E6F1FB", display: "flex", alignItems: "center",
            justifyContent: "center", fontSize: "1.3rem",
            fontFamily: "Inter-Medium", fontWeight: "500", color: "#0C447C",
          }}>
            {userObject.name?.trim().split(" ").map(w => w[0]).slice(0, 2).join("").toUpperCase()}
          </div>
          <div>
            <div style={{ fontSize: "1.5rem", fontFamily: "Inter-Medium", fontWeight: "500", color: "#101828" }}>
              {userObject.name}
            </div>
            <div style={{ fontSize: "1.2rem", fontFamily: "Inter-Medium", color: "#667085" }}>
              {userObject.roleId?.title || ""}
            </div>
          </div>
          {userObject.contactNumber && (
            <div style={{ fontSize: "1.3rem", fontFamily: "Inter-Medium", color: "#344054" }}>
              📞 {userObject.contactNumber.toString().slice(0,4)+"****"+userObject.contactNumber.toString().slice(-4)}
            </div>
          )}
          {userObject.email && (
            <div style={{ fontSize: "1.3rem", fontFamily: "Inter-Medium", color: "#344054" }}>
              ✉ {userObject.email}
            </div>
          )}
          <div style={{
            fontSize: "1.2rem", fontFamily: "Inter-Medium", padding: "0.2rem 0.8rem",
            borderRadius: "20px",
            background: userObject.isActive ? "#ECFDF3" : "#FEF3F2",
            color: userObject.isActive ? "#027A48" : "#B42318", fontWeight: "500",
          }}>
            {userObject.isActive ? "Active" : "Blocked"}
          </div>
          {userObject.roleId?.accessibleTabs && (
            <div style={{ display: "flex", gap: "0.6rem", flexWrap: "wrap", marginLeft: "auto" }}>
              {Object.keys(userObject.roleId.accessibleTabs).slice(0, 3).map(tab => (
                <div key={tab} style={{
                  fontSize: "1.1rem", fontFamily: "Inter-Medium", padding: "0.2rem 0.8rem",
                  borderRadius: "20px", background: "#E6F1FB", color: "#0C447C",
                }}>{tab}</div>
              ))}
              {Object.keys(userObject.roleId.accessibleTabs).length > 3 && (
                <div style={{
                  fontSize: "1.1rem", fontFamily: "Inter-Medium", padding: "0.2rem 0.8rem",
                  borderRadius: "20px", background: "#F2F4F7", color: "#344054",
                }}>+{Object.keys(userObject.roleId.accessibleTabs).length - 3}</div>
              )}
            </div>
          )}
        </div>
      )}

      <Box className={cssClasses.TabsWrapper}>
        <TabContext value={mainTabs.find((f) => f.isSelected).value}>
          <TabsMenu
            selectedColor={"#1570EF"}
            selectedBackgroundColor={"#FFFFFF"}
            stylesForTab={{
              color: "#344054",
              fontSize: "1.6rem",
              fontStyle: "normal",
              fontWeight: "500",
              lineHeight: "2.4rem",
              padding: "0.8rem 1.2rem",
              textTransform: "unset",
              borderBottom: "1px solid #EAECF0",
            }}
            borderColor={"#1570EFs"}
            stylesForWrapper={{
              padding: "1.5rem",
              background: "#FFFFFF",
            }}
            list={mainTabs}
            value={mainTabs.find((f) => f.isSelected).value}
            handleChange={(e, value) => {
              e.preventDefault();
              console.log("on tab change : ", value);
              onTabChange(value);
            }}
          />
          <TabPanel
            className={cssClasses.tabPanel}
            value={"Add Details"}
            index={0}
          >
            <Box className={cssClasses.mainTabPanelWrapper}>
              <AddDetails
                userObject={userObject}
                ref={addDetailsRef}
                setUserObject={setUserObject}
                onTabChange={onTabChange}
              />
            </Box>
          </TabPanel>
          <TabPanel
            className={cssClasses.tabPanel}
            value={"Assign Role"}
            index={1}
          >
            <Box className={cssClasses.mainTabPanelWrapper}>
              <AssignRole
                userObject={userObject}
                ref={assignRoleRef}
                setUserObject={setUserObject}
                onTabChange={onTabChange}
              />
            </Box>
          </TabPanel>
          <TabPanel
            className={cssClasses.tabPanel}
            value={"Hierarchy"}
            index={2}
          >
            <Box className={cssClasses.mainTabPanelWrapper}>
              <Hierarchy onTabChange={onTabChange} />
            </Box>
          </TabPanel>
          <TabPanel className={cssClasses.tabPanel} value={"Target"} index={3}>
            <Box className={cssClasses.mainTabPanelWrapper}>
              <Target
                ref={targetRef}
                userObject={userObject}
                setUserObject={setUserObject}
                onTabChange={onTabChange}
              />
            </Box>
          </TabPanel>

          <TabPanel
            className={cssClasses.tabPanel}
            value={"Assigned Projects"}
            index={3}
          >
            <Box className={cssClasses.mainTabPanelWrapper}>
              <AssignProject
                ref={assignProjectRef}
                userObject={userObject}
                setUserObject={setUserObject}
                onTabChange={onTabChange}
              />
            </Box>
          </TabPanel>
        </TabContext>
      </Box>
    </div>
  );
}

export default CreateUser;
